import { Rank } from '../types';

/**
 * الوظيفة column = the employee's rank in Arabic. Looks up the rank by its
 * English name in the Ranks module and returns its arabicName.
 */
export const getArabicRankName = (ranks: Rank[], rankName?: string, fallback?: string): string => {
  if (!rankName) return fallback || '-';
  const match = ranks.find(
    (r) => (r.name || '').trim().toLowerCase() === rankName.trim().toLowerCase()
  );
  return match?.arabicName || fallback || '-';
};
